<template>
	<v-container grid-list-md class="py-0">
		<v-layout row wrap>
			<v-flex xs12 md6>
				<ValidationProvider
					rules="required"
					name="customer_id"
					v-slot="{ errors, valid }"
				>
					<v-autocomplete
						v-model="item.customer_id"
						:items="customers"
						item-value="id"
						item-text="full_display_name"
						:label="$t('label.customer')"
						filled
						data-vv-name="customer_id"
						class="required"
						:error-messages="errors"
						:append-icon="valid ? 'mdi-check' : null"
					></v-autocomplete>
				</ValidationProvider>
			</v-flex>
			<v-flex xs12 md6>
				<ValidationProvider
					rules="required"
					name="coupon_id"
					v-slot="{ errors, valid }"
				>
					<v-autocomplete
						v-model="item.coupon_id"
						:items="coupons"
						item-value="id"
						item-text="name"
						:label="$t('label.coupon')"
						filled
						data-vv-name="coupon_id"
						class="required"
						:error-messages="errors"
						:append-icon="valid ? 'mdi-check' : null"
					></v-autocomplete>
				</ValidationProvider>
			</v-flex>
			<v-flex xs12 md6>
				<ValidationProvider
					name="membership_id"
					v-slot="{ errors, valid }"
				>
					<v-autocomplete
						v-model="item.payment_status"
						:items="payment_statuses"
						:label="$t('label.payment_status')"
						:errors="errors"
						:valid="valid"
						filled
					></v-autocomplete>
				</ValidationProvider>
			</v-flex>
			<v-flex xs12 md6>
				<ValidationProvider
					name="membership_id"
					v-slot="{ errors, valid }"
				>
					<v-autocomplete
						v-model="item.payment_method_code"
						:items="payment_methods"
						:label="$t('label.payment_method_code')"
						:errors="errors"
						:valid="valid"
						filled
					></v-autocomplete>
				</ValidationProvider>
			</v-flex>
			<v-flex xs12 md6>
				<ValidationProvider name="via" v-slot="{ errors, valid }">
					<v-autocomplete
						v-model="item.via"
						:items="vias"
						:label="$t('label.via')"
						:errors="errors"
						:valid="valid"
						filled
					></v-autocomplete>
				</ValidationProvider>
			</v-flex>
			<v-flex xs12 md4>
				<v-switch
					v-model="item.paid"
					inset
					:label="$t('Paid')"
				></v-switch>
			</v-flex>
			<v-flex xs6 md12>
				<v-textarea
					:label="$t('Description')"
					v-model="item.description"
					rows="3"
				>
				</v-textarea>
			</v-flex>
		</v-layout>
	</v-container>
</template>

<script>
export default {
	props: ["value", "customers", "coupons"],
	data() {
		return {
			payment_statuses: [
				{
					text: this.$t("Pending"),
					value: "pending",
				},
				{
					text: this.$t("Paid"),
					value: "paid",
				},
				{
					text: this.$t("Canceled"),
					value: "canceled",
				},
				{
					text: this.$t("Refunded"),
					value: "refunded",
				},
				{
					text: this.$t("Failed"),
					value: "failed",
				},
				{
					text: this.$t("Expired"),
					value: "expired",
				},
			],
			payment_methods: [
				{
					text: this.$t("label.COD"),
					value: "COD",
				},
				{
					text: this.$t("label.PAYWAY"),
					value: "PAYWAY",
				},
				{
					text: this.$t("label.ABAPAY"),
					value: "ABAPAY",
				},
				{
					text: this.$t("label.CARD"),
					value: "CARD",
				},
			],
			vias: [
				{
					text: this.$t("Manual"),
					value: "manual",
				},
				{
					text: this.$t("Web"),
					value: "web",
				},
				{
					text: this.$t("Mobile"),
					value: "mobile",
				},
			],
		};
	},
	computed: {
		item: {
			get() {
				return this.value;
			},
			set(value) {
				this.$emit("input", value);
			},
		},
	},
};
</script>